import { render, staticRenderFns } from "./sensitiveWordsManage.vue?vue&type=template&id=3298edfc&scoped=true"
import script from "./sensitiveWordsManage.vue?vue&type=script&lang=js"
export * from "./sensitiveWordsManage.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWordsManage.vue?vue&type=style&index=0&id=3298edfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298edfc",
  null
  
)

export default component.exports